import {
    Typography,
    useTheme,
    Box,
    useMediaQuery,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';

import LinkRouter from '../../../components/LinkRouter';
import BreadcrumbsComponent from '../../../components/BreadcrumbsComponent';
import { IBreadcrumb } from '../../../components/BreadcrumbsComponent/types';
import AnnouncementsCarousel from '../Announcements/AnnouncementsCarousel';
import Reporting from '../HomePage/reportingSmall';
import AnnouncementsCarouselTablet from '../Announcements/AnnouncementsCarouselTablet';
import AnnouncementsCarouselPhone from '../Announcements/AnnouncementsCarouselPhone';
import HideForms from '../../../components/SendPulseForms/hide';



// Освітнім закладам
const ForEducationalInstitutions = () => {
    const { palette } = useTheme();
    const theme = useTheme();
    const navigate = useNavigate();

    const isXl = useMediaQuery(theme.breakpoints.only("xl"));
    const isLg = useMediaQuery(theme.breakpoints.only("lg"));
    const isMd = useMediaQuery(theme.breakpoints.only("md"));
    const isXs = useMediaQuery(theme.breakpoints.down("md"));

    const [breadcrumbs, setBreadcrumbs] = useState<Array<IBreadcrumb>>([
        { name: "Партнерам", urlSlug: "/for-partners" },
        { name: "Освітнім закладам", urlSlug: "" },
    ]);

    useEffect(() => {
        document.title = `Освітнім закладам`;

    }, [])

    return (
        <>
            <HideForms />
            <Box sx={{ mb: { xs: "43px", lg: "120px" } }}>
                <Box sx={{ my: { xs: "11px", md: "28px", lg: "20px" }, mb: { xs: "28px", md: "0px" } }}>
                    <BreadcrumbsComponent elements={breadcrumbs} />
                </Box>
                <Typography variant="h1" fontFamily="Druk Wide, sans-serif" fontWeight="bold" fontSize={{ xs: "26px", lg: "36px" }} lineHeight="38px">
                    Освітнім закладам
                </Typography>
                <Typography variant="h5" fontFamily="Fixel Display, sans-serif" fontWeight="600" sx={{ mt: { xs: "14px", lg: "34px" }, mb: { xs: "43px", lg: "100px" } }}>
                    Ми прагнемо залучати молодь до активного пізнання культури та історії, і саме співпраця з освітніми закладами допомагає нам досягти цієї мети. Ми пропонуємо освітні програми, інтерактивні лекції, майстер-класи та креативні проєкти, які доповнюють шкільну/університетську освіту.
                    <br /><br />
                    Ваша участь у наших ініціативах дозволить учням/студентам поглибити знання, розвинути критичне мислення та творчий підхід. У свою чергу, ми готові залучати фахівців, адаптувати наші програми до навчальних планів та розробляти індивідуальні проєкти для вашого закладу.
                </Typography>
                {/* Анонси */}
                {(isXl || isLg) && <AnnouncementsCarousel />}
                {isMd && <AnnouncementsCarouselTablet />}
                {isXs && <AnnouncementsCarouselPhone />}
                {/* Наша звітність */}
                <Reporting />
            </Box>
        </>
    )
}

export default ForEducationalInstitutions